import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { FilterRequest } from 'src/app/models/virtual-store/filter-request.model';
import { FilterResponse } from 'src/app/models/virtual-store/filter-response.model';
import { CheckableItem } from 'src/app/core/models/checkable-item.model';
import { LabelType, Options } from 'ng5-slider';
import { Product } from 'src/app/models/virtual-store/product.model';
import { Subscription } from 'rxjs';
import { ProductCategory } from 'src/app/models/virtual-store/product-category.model';
import { CommonService } from 'src/app/services/common.service';
import { MatPaginator } from '@angular/material';
import { AuthService } from 'src/app/core/services/auth.service';
import { Basic } from 'src/app/core/models/basic.model';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent implements OnInit {
  selectedSortMode: string;
  selectedCategory = new ProductCategory();
  subCategoryList: CheckableItem<FilterResponse>[] = [];
  brandList: CheckableItem<FilterResponse>[] = [];
  sectionList: CheckableItem<FilterResponse>[] = [];
  productList: Product[] = [];
  floor: number = 0;
  ceil: number = 0;
  matSliderOptions: Options = {
    floor: 0,
    ceil: 0,
    translate:(value:number, label:LabelType):string=>{
      switch(label){
        case LabelType.Low:
          return '<b>S/' + value;
        case LabelType.High:
          return '<b>S/' + value;
        default:
          return 'S/' + value
      }
    }
  };
  ocultarcombo: Boolean;
  currentPage: number = 0;
  pageSize: number = 24;
  totalProductCount: number = 0;
  viewType = 'grid';

  paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) set content(content: MatPaginator) {}

  showFilter:boolean;
  showPrice: boolean;
  @ViewChild('responsive', {static:true}) ancho:ElementRef;
  showFilterSub: Subscription;
  selectedMultiFilterSub: Subscription;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
  
    this.showFilter = event.target.innerWidth < 769 ? false : true;
  
  }
 

  constructor(private virtualStoreService: VirtualStoreService,
    private authService: AuthService,
    private commonService: CommonService) {
    // this.showFilterSub = this.commonService.filterActivatedAnnounced.subscribe(status => {
    //   this.showFilter = status;
    // });

    // this.selectedMultiFilterSub = this.commonService.categoryAndFilterSelectedAnnounced.subscribe((filterList:  Basic<string>[]) => {
    //   this.selectedCategory.code =filterList[0].code;
    //   this.selectedSortMode = filterList[1].code;
    //   this.cleanFilters();
    //   this.getFilters();
    //   this.getProducts();
    // });
  }

  ngOnInit() {
    localStorage.setItem('_showingDetail', 'false');

    this.subscriptionToFiltersChange()

    if (this.authService.getAuthToken() && !this.authService.checkIfItIsInsideIframe()) {
      this.pageSize = 24;    
      this.ocultarcombo = false;
    }
    else
    {
      this.ocultarcombo = false;
      this.pageSize = 24;
    }

    if (this.ancho.nativeElement.offsetWidth < 768) {
      this.showFilter = false
    }
  }

  subscriptionToFiltersChange() {
  
    let isSortChange: boolean = false;

    this.showFilterSub = this.commonService.filterActivatedAnnounced.subscribe(status => {
      this.showFilter = status;
    });

    this.selectedMultiFilterSub = this.commonService.categoryAndFilterSelectedAnnounced.subscribe((filterList:  Basic<string>[]) => {
      this.selectedCategory.code =filterList[0].code;

      if (!isNullOrUndefined(this.selectedSortMode) && this.selectedSortMode != '') {
        if (this.selectedSortMode != filterList[1].code) isSortChange = true;
      }
      
      this.selectedSortMode = filterList[1].code;

      if (!isSortChange) {
        this.cleanFilters();
        this.getFilters();
      }
      this.getProducts();
    });

  }

  ngOnDestroy() {
    this.selectedMultiFilterSub.unsubscribe();
    this.showFilterSub.unsubscribe();
  }

  viewList() {
    this.viewType = 'list';
  }
  viewGrid() {
    this.viewType = 'grid';
  }

  buildFilter() {
    let filterRequest = new FilterRequest();
    filterRequest.categoryList = [parseInt(this.selectedCategory.code)]
    filterRequest.subCategoryList = this.subCategoryList.filter(x => x.checked).map(item => parseInt(item.data.key));
    filterRequest.brandList = this.brandList.filter(x => x.checked).map(item => parseInt(item.data.key));
    filterRequest.sectionList = this.sectionList.filter(x => x.checked).map(item => parseInt(item.data.key));
    filterRequest.sortMode = this.selectedSortMode;
    filterRequest.minPrice = this.floor;
    filterRequest.maxPrice = this.ceil;
    filterRequest.page = this.currentPage + 1;
    filterRequest.pageSize = this.pageSize;

    // console.log('CON ESTE FILTRO TRAERA DATA', filterRequest);

    return filterRequest;
  }

  cleanFilters() {
    this.subCategoryList = [];
    this.brandList = [];
    this.sectionList = [];

    const options: Options = Object.assign({}, this.matSliderOptions);
    options.floor = 0;
    this.floor = options.floor;
    options.ceil = 0;
    this.ceil = options.ceil;
    this.matSliderOptions = options;
  }

  getFilters() {
    this.virtualStoreService.getFilters(parseInt(this.selectedCategory.code)).subscribe(response => {
      if (response.valid) {
        this.subCategoryList = [];
        this.brandList = [];
        this.sectionList = [];
        response.data.map(
          filter => {
            switch (filter.groupId) {
              case 2: {
                this.subCategoryList.push(new CheckableItem(filter));
                break;
              }
              case 3: {
                this.brandList.push(new CheckableItem(filter));
                break;
              }
              case 4: {
                this.sectionList.push(new CheckableItem(filter));
                break;
              }
            }
          }
        )

        if (this.subCategoryList.length == 1) this.subCategoryList[0].check();
        if (this.brandList.length == 1) this.brandList[0].check();
        if (this.sectionList.length == 1) this.sectionList[0].check();

        let priceList = response.data.filter(x => x.groupId == 5).map(filter => parseFloat(filter.key.replace(',', '.')));
        if(priceList.length > 0 && (priceList[0] !== priceList[1])){
          this.showPrice = true;
          const options: Options = Object.assign({}, this.matSliderOptions);
          options.floor = Math.min.apply(null, priceList);
          this.floor = options.floor;
          options.ceil = Math.max.apply(null, priceList);
          this.ceil = options.ceil;
          this.matSliderOptions = options;
        } else {
          this.showPrice = false;
        }
      }
    })
  }

  isSamePrice(priceList: any[]): boolean {
    return priceList[0] == priceList[1];
  }

  filterChanged() {
    this.currentPage = 0;
    this.getProducts();
  }

  getProducts() {
    this.virtualStoreService.getProducts(this.buildFilter()).subscribe(response => {
      this.productList = response.data.list.map(product => {
        this.selectedCategory.tcea=product.category.tcea;
        this.selectedCategory.codeFilter=product.category.codeFilter;
        product.category = this.selectedCategory;       
        return product;
      })
      this.totalProductCount = response.data.count;
    })
  }
  pageChanged(event: any) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getProducts();
  }
}